import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-fire',
  templateUrl: './icon-fire.component.html',
  styles: []
})
export class IconFireComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
